import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FactoryService } from './factory.service';
import { BackendService } from './backend.service';
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";

@Injectable()
export class PicklistService {

    url;
    private _picklists: BehaviorSubject<any> = new BehaviorSubject({});
    private picklistsDataStore = {};
    private picklistDBMapping = {};
    optionalPicklist: ({ display: any; id: number })[] | Observable<any> | any;

    constructor(
        private backendService: BackendService,
        private factory: FactoryService,
        private translate: TranslateService
    ) {}

    get picklists(): Observable<any> {
        return this._picklists.asObservable();
    }

    get yesNoObservable(): Observable<any> {
        let options = new BehaviorSubject([
            {
                'id': '1',
                'display': this.translate.instant('misc.Yes')
            },
            {
                'id': '0',
                'display': this.translate.instant('misc.No')
            }
        ]);
        return options.asObservable();
    }

    get yesNoOptions() {
        return [
            {
                'value': 1,
                'label': this.translate.instant('misc.Yes')
            },
            {
                'value': 0,
                'label': this.translate.instant('misc.No')
            }
        ];
    }

    getPicklist(picklistName) {

        this.picklists.pipe(map(picklists => {
            picklists[picklistName];
        }));
        return this.picklists.pipe(map(picklists => picklists[picklistName]));
    }

    loadAll(): void {
        Object.keys(this.picklistsDataStore).forEach(picklistName => {
            this.loadPicklist(picklistName);
        });
    }

    loadPicklist(picklistName) {
        let config = this.picklistDBMapping[picklistName];
        if (config) {
            let resource = '';
            if (picklistName == 'rights') {
                resource = 'student/available-rights';
            } else {
                resource = 'picklists/'+ config.resource + '/' + picklistName;
            }
            this.backendService.getAll(config.params, resource)
                .subscribe(
                    (res) => {
                        this.picklistsDataStore[picklistName] = this.factory.picklistValuesFactory(res);
                        this._picklists.next(Object.assign({}, this.picklistsDataStore));
                    },
                    error => console.log('Could not fetch picklist' + picklistName, error)
                );
        }
    }
}
